import { SignatureV4 } from '@aws-sdk/signature-v4-universal';
import { parseUrl } from '@aws-sdk/url-parser-universal';
import { defer } from 'rxjs';
import { mergeMap, take } from 'rxjs/operators';
import { cached } from '../common/cached';
import { CoralInterceptor } from './interceptor';
/** Convert headers from map to list. */
const toHeaderList = (headers) => Object.entries(headers);
/**
 * Sign requests using the aws4-hmac-sha256 HTTP signing scheme.
 */
export class Aws4HmacSha256Interceptor extends CoralInterceptor {
    constructor(credentialsProvider) {
        super();
        this.credentials = defer(credentialsProvider).pipe(cached(credentials => credentials.expiration === undefined
            ? new Date(8640000000000000)
            : new Date(credentials.expiration * 1000 - 60000)));
    }
    intercept(request, next) {
        const httpSigning = request.config.httpSigning;
        if (!httpSigning || httpSigning.scheme !== 'aws4-hmac-sha256') {
            return next.handle(request);
        }
        return this.credentials.pipe(take(1), mergeMap(credentials => {
            const signer = new SignatureV4({
                service: httpSigning.service,
                region: httpSigning.region,
                credentials,
            });
            const endpoint = parseUrl(request.url);
            const body = typeof request.body === 'string' ? request.body : JSON.stringify(request.body);
            return signer.sign(Object.assign(Object.assign({}, endpoint), { body, method: request.method, headers: request.getHeaderBag() }), { signingDate: request.signingDate });
        }), mergeMap(signedRequest => next.handle(request.clone({
            body: signedRequest.body,
            headers: toHeaderList(signedRequest.headers),
        }))));
    }
}
